import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-poll-creation-title',
  templateUrl: 'poll-creation-title.component.html',
  styleUrls: ['./poll-creation-title.component.less', '../../../shared/common.less'],
})

export class PollCreationTitleComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Output() titleChange = new EventEmitter<string>();
  @Output() descriptionChange = new EventEmitter<string>();
  needPap: boolean = undefined;

  constructor() {}
  
  onTitleChange() {    
    this.titleChange.emit(this.title);
  }

  onDescriptionChange() {
    this.descriptionChange.emit(this.description);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  trackByIndex(index: number): number {
    return index;
  }

  
  ngOnInit(): void {
  }
}
